const ahrefsConsts = { defaultSyncInterval: 'each3Days' };

const crawlerConsts = {
  defaultCrawlingInterval: 'weekly',
};

export { ahrefsConsts, crawlerConsts };
